import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './HomePage';
import AdminLogin from './adminlogin';
import Dashboard from './Dashboard';
import SuperAdminDashboard from './SuperAdminDashboard';
import MemberDetails from './components/MemberDetails';
import TenantPublicHome, { DomainAwareHome, GymRouteGuard } from './TenantPublicHome';
import theme from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<DomainAwareHome />} />
            <Route path="/contact" element={<DomainAwareHome />} />
            <Route path="/gym" element={<GymRouteGuard><TenantPublicHome /></GymRouteGuard>} />
            <Route path="/gym/:tenantSlug" element={<GymRouteGuard><TenantPublicHome /></GymRouteGuard>} />
            <Route path="/gym/:tenantSlug/contact" element={<GymRouteGuard><TenantPublicHome contact /></GymRouteGuard>} />
            <Route path="/adminlogin" element={<AdminLogin />} />
            <Route path="/super-admin" element={<ProtectedRoute><SuperAdminDashboard /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/contact" element={<Navigate to="/gym" replace />} />
            <Route path="/memberdetails/:memberId" element={<ProtectedRoute><MemberDetails /></ProtectedRoute>} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;